export function getParentUrlIfInIframe() {
  let parentUrl;
  if (isInIframe) {
    try {
      parentUrl = document.referrer || window.top.location.href;
    } catch (e) {
      console.warn(
        'Unable to access parent URL due to cross-origin restrictions.'
      );
      parentUrl = '';
    }
  }

  return parentUrl;
}


export function isInIframe() {
  if (typeof window === 'undefined') {
    return true;
  }
  try {
    return window.self !== window.top;
  } catch (e) {
    // Accessing window.top throws an exception in cross-origin iframes
    return true;
  }
}